export default __webpack_public_path__ + "static/media/31.3a0cc5e1.svg";